import React from "react";
import styled from "styled-components";
import { useMutation, useQueryClient } from "@tanstack/react-query";
import { authLogout } from "common/auth/auth_api_common";
import { QUERY_KEYS } from "constant/react_query";
import { SCREEN_WIDTH_BREAKPOINT } from "constant/common_constants";
import MainNavGroup from "components/navigation/MainNavigation/MainNavGroup";
import MainNavItem from "components/navigation/MainNavigation/MainNavItem";
import DotsLine from "components/common/view_util/DotsLine";
import { ADM_NAV_ELEMENTS } from "constant/admin/navigation";

const SideMenu: React.FC = () => {
  const queryClient = useQueryClient();

  const { mutate: logout } = useMutation({
    mutationFn: async () => await authLogout(),
    onSuccess: () => {
      console.log("logout success");
      queryClient.invalidateQueries({
        queryKey: [QUERY_KEYS.AUTH_CURRENT_GET],
      });
    },
  });

  const lOutHandle = () => {
    console.log("logout");
    logout();
  };

  return (
    <Div>
      <img src="/images/logo.png" alt="Logo" />
      <MainNavGroup>
        <MainNavItem navElement={ADM_NAV_ELEMENTS.GROUPS} />
        <MainNavItem navElement={ADM_NAV_ELEMENTS.DL_UNITS} />
        <MainNavItem navElement={ADM_NAV_ELEMENTS.PHOTO_SERIES} />
        <MainNavItem navElement={ADM_NAV_ELEMENTS.USERS} />
        <MainNavItem navElement={ADM_NAV_ELEMENTS.HEMEROTEKA} target="_blank" />
      </MainNavGroup>
      <DotsLine />
      <LOutNavGroup>
        <SpanLOut onClick={lOutHandle}>{ADM_NAV_ELEMENTS.L_OUT.title}</SpanLOut>
      </LOutNavGroup>
    </Div>
  );
};

export default SideMenu;

const Div = styled.div`
  display: none;
  flex-direction: column;
  margin-top: 0;

  @media (min-width: ${SCREEN_WIDTH_BREAKPOINT}) {
    display: flex;
  }
`;

const LOutNavGroup = styled(MainNavGroup)`
  margin-top: 2em;
`;

const SpanLOut = styled.span`
  cursor: pointer;
  font-weight: bold;
  color: ${(props) =>
    (props.theme && props.theme.color && props.theme.color.link) ?? "auto"};
`;
